(function () {
  const TRANSITION_DURATION_MS = 180;
  const MIN_VISIBLE_DURATION_MS = 450;
  const STORAGE_KEY = 'page-transition-pending';
  const root = document.documentElement;
  const overlay = document.getElementById('PageTransitionOverlay');

  if (!overlay || overlay.hasAttribute('data-disabled')) {
    clearPendingTransition();
    return;
  }

  const isTransitionEnabled = overlay.dataset.enabled === 'true';
  if (!isTransitionEnabled) {
    clearPendingTransition();
    root.classList.remove('page-transition-incoming', 'page-transition-active');
    return;
  }

  let isNavigating = false;
  let pendingTransition = getPendingTransition();

  if (document.readyState === 'complete') {
    revealPage();
  }
  window.addEventListener('pageshow', revealPage);
  window.addEventListener('load', revealPage);

  document.addEventListener('click', onDocumentClick, true);

  function onDocumentClick(event) {
    if (event.defaultPrevented || isNavigating) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = resolveNavigationLink(event);
    if (!link || shouldSkipLink(link)) return;

    const destination = new URL(link.href, window.location.href);
    if (!isEligibleNavigation(destination, link)) return;

    isNavigating = true;
    event.preventDefault();

    try {
      pendingTransition = {
        destination: destination.pathname + destination.search,
        timestamp: Date.now(),
      };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pendingTransition));
    } catch (error) {
      // Continue navigation even if sessionStorage is unavailable.
    }

    root.classList.remove('page-transition-incoming');
    root.classList.add('page-transition-active');

    window.setTimeout(function () {
      window.location.assign(destination.href);
    }, TRANSITION_DURATION_MS);
  }

  function revealPage() {
    if (!root.classList.contains('page-transition-incoming')) {
      clearPendingTransition();
      root.classList.remove('page-transition-active');
      return;
    }

    const startedAt = pendingTransition?.timestamp || Date.now();
    const elapsed = Date.now() - startedAt;
    const remainingVisibleTime = Math.max(0, MIN_VISIBLE_DURATION_MS - elapsed);

    window.setTimeout(function () {
      window.requestAnimationFrame(function () {
        root.classList.remove('page-transition-active', 'page-transition-incoming');
        window.setTimeout(clearPendingTransition, TRANSITION_DURATION_MS);
      });
    }, remainingVisibleTime);
  }

  function shouldSkipLink(link) {
    const href = link.getAttribute('href');

    if (!href) return true;
    if (link.hasAttribute('download')) return true;
    if (link.target && link.target.toLowerCase() !== '_self') return true;
    if (link.relList.contains('external')) return true;
    if (link.dataset.noPageTransition !== undefined) return true;
    if (href.charAt(0) === '#') return true;

    const normalizedHref = href.trim().toLowerCase();
    return normalizedHref.startsWith('mailto:') || normalizedHref.startsWith('tel:') || normalizedHref.startsWith('javascript:');
  }

  function isEligibleNavigation(destination, link) {
    if (destination.origin !== window.location.origin) return false;
    if (destination.pathname === window.location.pathname && destination.search === window.location.search) return false;
    if (destination.hash && destination.pathname === window.location.pathname && destination.search === window.location.search) return false;
    if (link.closest('shopify-section')?.classList.contains('shopify-section--header') && link.hasAttribute('aria-expanded')) return false;

    return true;
  }

  function resolveNavigationLink(event) {
    if (!(event.target instanceof Element)) return null;

    const directLink = event.target.closest('a[href]');
    if (directLink instanceof HTMLAnchorElement) return directLink;

    const cardContainer = event.target.closest('product-card, product-card-link, .resource-card, .collection-card');
    if (!(cardContainer instanceof Element)) return null;

    return cardContainer.querySelector(
      'a[href][ref="productCardLink"], a[href][ref="cardGalleryLink"], a[href].product-card__link, a[href].resource-card__link, a[href].collection-card__link, a[href]'
    );
  }

  function clearPendingTransition() {
    pendingTransition = null;
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Ignore storage cleanup issues.
    }
  }

  function getPendingTransition() {
    try {
      const storedTransition = sessionStorage.getItem(STORAGE_KEY);
      return storedTransition ? JSON.parse(storedTransition) : null;
    } catch (error) {
      return null;
    }
  }
})();
